export default __webpack_public_path__ + "static/media/secure.7370ac46.svg";